import { EVENT_ID } from '../../const';

const NOTIFICATION = {
  CLUB_CONTACT: 'Find Football Club Contact',
  WELFARE_OFFICER: 'Find Football Welfare Officer',
  PLAYER_PARENT: 'Find Football Player Parent',
};

export const PAYLOAD_TYPE = {
  PLAYER_PARENT: 'PLAYER_PARENT',
  CLUB_CONTACT: 'CLUB_CONTACT',
  WELFARE_OFFICER: 'WELFARE_OFFICER',
};

export const getRequestPayload = (WgsClubID, data, title, type) => {
  if (type === PAYLOAD_TYPE.PLAYER_PARENT) {
    return {
      WgsClubId: WgsClubID,
      EventId: EVENT_ID.PLAYER_PARENT,
      NotificationType: NOTIFICATION.PLAYER_PARENT,
      EmailId: data.email,
      EmailSubjectData: {
        Firstname: data.firstName,
        ClubName: title,
        Subject: `Thanks for getting in touch about ${title} through Find Football.`,
      },
    };
  } else if (type === PAYLOAD_TYPE.WELFARE_OFFICER) {
    return {
      WgsClubId: WgsClubID,
      EventId: EVENT_ID.WELFARE_OFFICER,
      NotificationType: NOTIFICATION.WELFARE_OFFICER,
      EmailId: null,
      EmailSubjectData: {
        QueryFrom: `${data.firstName} ${data.lastName}`,
        Email: data.email,
        QueryIsAbout: data.queryIsAbout,
        PlayerAge: data.age,
        Subject: `${title} has received an message through Find Football regarding a youth player`,
        QueryDescription: data.description,
        ClubName: title,
      },
    };
  } else {
    // PAYLOAD_TYPE.CLUB_CONTACT (default)
    return {
      WgsClubId: WgsClubID,
      EventId: EVENT_ID.CLUB_CONTACT,
      NotificationType: NOTIFICATION.CLUB_CONTACT,
      EmailId: null,
      EmailSubjectData: {
        QueryFrom: `${data.firstName} ${data.lastName}`,
        Email: data.email,
        QueryIsAbout: data.queryIsAbout,
        PlayerAge: data.age,
        Subject: `${data.firstName} has messaged you through Find Football about ${title}`,
        QueryDescription: data.description,
        ClubName: title,
      },
    };
  }
};
